import { Route } from '../../shared/models/route';
import { translationNamespace } from '../constants/translation-resources';
import { BatchesListView } from '../views/batches-list';
import batchesIcon from '../assets/images/menu-items/icon_acknowledge.svg';
import { Layout } from '../../shared/models/layout';

export const approvalRoutes: Route = {
  path: '/documents',
  nameTranslationKey: `${translationNamespace}:navigation.approval`,
  icon: batchesIcon,
  displayInSideNavigation: true,
  hideIfEmpty: true,
  meta: {
    layout: Layout.SIDE_NAVIGATION,
    requiredPermission: ['BATCH', 'READ'],
  },
  children: [
    {
      path: '/approval',
      nameTranslationKey: `${translationNamespace}:navigation.approveDocuments`,
      view: BatchesListView,
      displayInSideNavigation: true,
    },
    {
      path: '/processed',
      nameTranslationKey: `${translationNamespace}:navigation.processedDocuments`,
      view: BatchesListView,
      displayInSideNavigation: true,
    },
  ],
};
